<template>
  <el-row :gutter="20">
    <el-col :span="12" :offset="6">
      <el-form ref="form" label-width="0px">
        <div class="label-contract">
          {{ $t('refCode') }}:
        </div>
        <el-form-item>
          <el-row>
            <el-col :span="16">
              <el-input v-model="dynamicRefCode"
                        :disabled="autoRefCode"
                        class="text-uppercase">
              </el-input> <br>
              <el-checkbox v-model="autoRefCode" v-if="refCodeFormat.trim() !== ''"
                           @change="onAutoGenerateRefCodeCheckChange()">
                {{$t('autoGenRefCode')}}
              </el-checkbox>
            </el-col>
            <el-col :span="1" style="text-align: center"><span style="font-size: 18px">&nbsp;/&nbsp;</span> </el-col>
            <el-col :span="7">
              <el-dropdown>
                <el-button type="primary" style="padding: 12px 12px">
                  {{ bindRefCodeSuffixType() }} <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="onChangeRefCodeSuffixType(SPECIAL_OFFER_REF_CODE_TYPE.AGENT_NAME)">
                    {{$t('agentName')}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
          </el-row>
        </el-form-item>
        <div class="label-contract">
          {{ $t('specialOfferValidFrom') }}:
        </div>
        <el-form-item>
          <el-date-picker v-model="specialOfferValidPeriod"
                          type="daterange"
                          format="d MMMM yyyy"
                          value-format="yyyy-MM-dd"
                          start-placeholder="From"
                          end-placeholder="To"
                          style="width: 100%;"
                          @change="onGeneralDataChange">
          </el-date-picker>
        </el-form-item>
        <div class="label-contract">
          {{ $t('salePerson') }}:
        </div>
        <el-form-item>
          <el-select
            v-model="selectedSalePersonId"
            :placeholder="$t('pleaseSelectSalePerson')"
            style="width: 100%"
            @change="onGeneralDataChange">
            <el-option
              v-for="(salePerson, index) in displaySalePersonList"
              :key="index"
              :label="`${salePerson.firstName} ${salePerson.lastName}`"
              :value="salePerson.id">
            </el-option>
          </el-select>
          <div>
            <el-checkbox v-model="isAddSignature" :disabled="signatureUrl === ''" @change="onGeneralDataChange">
              <span>{{ $t('addSignatureInSpecialOffer') }}</span>
            </el-checkbox>
            <div v-if="isAddSignature === true && signatureUrl !== ''">
              <img height="80px" alt="Signature" :src="signatureUrl">
            </div>
          </div>
        </el-form-item>
        <div class="contract-data-version" style="margin: 20px 0 20px 0" v-if="isUpdatedSalePerson()">
          <div class="contract-data-updated">
            <div style="padding: 20px 0 0 20px">
              <strong>*{{$t('updatedSalePersonMessage')}}</strong>
            </div>
            <el-radio-group style="padding-left: 40px" v-model="salePersonDataVersion" fill="#ff0000" @change="onGeneralDataChange">
              <div class="contract-data-version-radio">
                <el-radio v-model="salePersonDataVersion" :label="DATA_VERSION.SELECTED">{{$t('selectedVersion')}} ({{bindUpdatedAt(tmpSelectedSalePerson.updatedAt)}})</el-radio>
              </div>
              <div class="contract-data-version-radio">
                <el-radio v-model="salePersonDataVersion" :label="DATA_VERSION.LATEST">{{$t('latestVersion')}} ({{bindLatestUpdatedAt(tmpSelectedSalePerson.id)}})</el-radio>
              </div>
            </el-radio-group>
          </div>
        </div>
        <div class="contract-data-version" style="margin: 20px 0 20px 0" v-if="isDeletedSalePerson()">
          <div class="contract-data-deleted">
            <div style="padding: 20px 0 0 20px">
              <strong style="color: #dd3333">*{{$t('deletedSalePersonMessage')}}</strong>
            </div>
            <el-radio-group style="padding-left: 40px" v-model="selectedSalePersonId" fill="#ff0000" >
              <el-radio :label="selectedSalePersonId" class="contract-data-version-radio">{{$t('selectedVersion')}} ({{bindUpdatedAt(tmpSelectedSalePerson.updatedAt)}})</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="label-contract">
          {{ $t('issueDate') }}:
        </div>
        <el-form-item>
          <el-date-picker v-model="specialOfferIssueDate"
                          type="date"
                          format="d MMMM yyyy"
                          value-format="yyyy-MM-dd"
                          style="width: 100%;"
                          @change="onGeneralDataChange">
          </el-date-picker>
        </el-form-item>
          <div class="label-contract">
            {{ $t('bodyMessage') }}:
          </div>
        <el-form-item>
          <editor-component v-model="bodyMessage"></editor-component>
        </el-form-item>
          <div class="label-contract">
            {{ $t('footerMessage') }}:
          </div>
        <el-form-item>
          <editor-component v-model="footerMessage"></editor-component>
        </el-form-item>
          <div class="label-contract">
            <el-checkbox v-model="isDisplayInternalNote"></el-checkbox>
            {{ $t('internalNote') }}:
          </div>
        <el-form-item v-show="isDisplayInternalNote">
          <el-input
            type="textarea"
            :rows="5"
            v-model="internalNote"
            @change="onGeneralDataChange"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</template>

<script>
import i18nMessages from '@/translations/SpecialOffer/components/TabSpecialOfferGeneralComponent.i18n'
import EditorComponent from '@/components/EditorComponent'
import { getISODateFormat } from '@/helpers'
import { genPreviewRefCode } from '@/domains/special-offer-domain'
import { SPECIAL_OFFER_REF_CODE_TYPE } from '@/configs/constant'
import { get, cloneDeep } from 'lodash'
import { isUpdatedData, isDeletedData, DATA_VERSION } from '@/services/version-service'
import { dateFormat } from '@/helpers/datetime'

export default {
  name: 'TabGeneralComponent',
  i18n: { messages: i18nMessages },
  components: { EditorComponent },
  model: {
    prop: 'specialOfferDetail',
    event: 'onGeneralDetailChange'
  },
  props: {
    hotel: {
      type: Object,
      default: () => {
        return {}
      }
    },
    specialOfferDetail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    salePersonList: {
      type: Array,
      default: () => {
        return []
      }
    },
    refCodeFormat: {
      type: String,
      default: ''
    },
    marketList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    dynamicRefCode: {
      get () {
        if (this.autoRefCode === true) {
          return genPreviewRefCode(this.specialOfferDetail, this.refCodeFormat, this.marketList)
        }

        return this.refCode
      },
      set (newVal) {
        this.refCode = newVal
        this.onGeneralDataChange()
      }
    },
    bodyMessage: {
      get () {
        const bodyMessage = get(this.specialOfferDetail, 'general.bodyMessage', '')
        return bodyMessage
      },
      set (newVal) {
        this.newBodyMessage = newVal
        this.onGeneralDataChange()
      }
    },
    footerMessage: {
      get () {
        const footerMessage = get(this.specialOfferDetail, 'general.footerMessage', '')
        return footerMessage
      },
      set (newVal) {
        this.newFooterMessage = newVal
        this.onGeneralDataChange()
      }
    }
  },
  created: function () {
    const autoRefCode = _isAutoRefCode(this.refCodeFormat, this.specialOfferDetail)
    const generalData = get(this.specialOfferDetail, 'general', {})
    const specialOfferValidStart = get(generalData, 'startDate', '')
    const specialOfferValidEnd = get(generalData, 'endDate', '')
    const specialOfferIssueDate = get(generalData, 'issueDate', '')

    this.newBodyMessage = get(generalData, 'bodyMessage', '')
    this.newFooterMessage = get(generalData, 'footerMessage', '')
    this.internalNote = get(generalData, 'internalNote', '')

    const refCode = _initRefCode(this.specialOfferDetail, this.refCodeFormat, this.marketList)
    const startDate = (specialOfferValidStart !== '') ? getISODateFormat(new Date(specialOfferValidStart)) : ''
    const endDate = (specialOfferValidEnd !== '') ? getISODateFormat(new Date(specialOfferValidEnd)) : ''
    const issueDate = (specialOfferIssueDate !== '') ? getISODateFormat(new Date(specialOfferIssueDate)) : ''

    this.specialOfferValidPeriod.push(startDate, endDate)
    this.specialOfferIssueDate = issueDate
    this.refCode = refCode
    this.autoRefCode = autoRefCode
    this.specialOfferDetail.refCode = refCode
    this.specialOfferDetail.autoRefCode = autoRefCode
    this.refCodeSuffixType = get(this.specialOfferDetail, 'refCodeSuffixType', '')

    const salePerson = get(this.specialOfferDetail, 'hotel.salePerson', {})
    const salePersonId = get(salePerson, 'id', '')
    const isAddSignature = Boolean(get(salePerson, 'isAddSignature', 0))

    this.selectedSalePersonId = salePersonId
    this.tmpSelectedSalePerson = cloneDeep(salePerson)
    this.tmpSelectedSalePersonId = get(this.tmpSelectedSalePerson, 'id', '')

    this.signatureUrl = get(salePerson, 'signatureUrl', '')
    this.isAddSignature = (this.tmpSelectedSalePersonId === '') ? true : isAddSignature

    const salePersonUpdatedAt = get(salePerson, 'updatedAt', '')
    if (this.tmpSelectedSalePersonId !== '' && salePersonUpdatedAt === '') {
      const lastedSalePerson = this.salePersonList.find(item => item.id === salePersonId)

      if (lastedSalePerson !== undefined) {
        this.specialOfferDetail.hotel = Object.assign({}, this.specialOfferDetail.hotel, { salePerson: lastedSalePerson })
        this.tmpSelectedSalePerson = cloneDeep(lastedSalePerson)
        this.tmpSelectedSalePersonId = get(this.tmpSelectedSalePerson, 'id', '')
        this.signatureUrl = get(lastedSalePerson, 'signatureUrl', '')
        this.isAddSignature = false

        const newSpecialOfferDetail = Object.assign({}, this.specialOfferDetail)
        this.$emit('onGeneralDetailChange', newSpecialOfferDetail)
      }
    }

    if (this.internalNote !== '') {
      this.isDisplayInternalNote = true
    }

    this._prepareSalePersonList()
  },
  data () {
    return {
      DATA_VERSION: DATA_VERSION,
      SPECIAL_OFFER_REF_CODE_TYPE,
      autoRefCode: false,
      refCode: '',
      refCodeSuffixType: SPECIAL_OFFER_REF_CODE_TYPE.AGENT_NAME,
      specialOfferValidPeriod: [],
      selectedSalePersonId: '',
      specialOfferIssueDate: '',
      newBodyMessage: '',
      newFooterMessage: '',
      internalNote: '',
      signatureUrl: '',
      isAddSignature: true,
      isDisplayInternalNote: false,
      salePersonDataVersion: DATA_VERSION.SELECTED,
      tmpSelectedSalePersonId: '',
      tmpSelectedSalePerson: {},
      displaySalePersonList: []
    }
  },
  methods: {
    onGeneralDataChange: function () {
      const startDateIndex = 0
      const endDateIndex = 1
      const salePerson = this._getUpdateSalePerson()
      const periodStart = _getPeriodDate(this.specialOfferValidPeriod, startDateIndex)
      const periodEnd = _getPeriodDate(this.specialOfferValidPeriod, endDateIndex)
      const hotelInfo = get(this.specialOfferDetail, 'hotel', {})
      const newHotelInfo = Object.assign({}, hotelInfo, { salePerson: (salePerson === undefined) ? {} : salePerson })
      const generalData = {
        startDate: periodStart,
        endDate: periodEnd,
        issueDate: this.specialOfferIssueDate,
        bodyMessage: this.newBodyMessage,
        footerMessage: this.newFooterMessage,
        internalNote: this.internalNote
      }
      const tabGeneralAllData = {
        refCode: this.refCode.toUpperCase(),
        refCodeSuffixType: this.refCodeSuffixType,
        autoRefCode: this.autoRefCode,
        general: generalData,
        hotel: newHotelInfo
      }
      const specialOfferDetail = Object.assign({}, this.specialOfferDetail, tabGeneralAllData)
      if (this.autoRefCode === true) {
        this.refCode = genPreviewRefCode(specialOfferDetail, this.refCodeFormat, this.marketList)
      }

      const newRefCode = {
        refCode: this.refCode.toUpperCase()
      }

      const newSpecialOfferDetail = Object.assign({}, specialOfferDetail, newRefCode)
      this.$emit('onGeneralDetailChange', newSpecialOfferDetail)
    },
    onAutoGenerateRefCodeCheckChange: function () {
      this.onGeneralDataChange()
    },
    bindRefCodeSuffixType: function () {
      switch (this.refCodeSuffixType) {
        case SPECIAL_OFFER_REF_CODE_TYPE.AGENT_NAME:
          return this.$t('agentName').toUpperCase()
        default:
          return 'N/A'
      }
    },
    onChangeRefCodeSuffixType: function (refCodeSuffixType) {
      this.refCodeSuffixType = refCodeSuffixType
      this.onGeneralDataChange()
    },
    bindLatestUpdatedAt: function (salePersonId) {
      const salePerson = this.salePersonList.find(item => item.id === salePersonId)

      if (salePerson !== undefined) {
        const date = new Date(salePerson.updatedAt)
        return dateFormat.long(date)
      }
    },
    bindUpdatedAt: function (updatedDate) {
      if (updatedDate === undefined || updatedDate === 0) {
        return '-'
      }

      const date = new Date(updatedDate)
      return dateFormat.long(date)
    },
    isUpdatedSalePerson: function () {
      if (this.selectedSalePersonId === '') {
        return false
      }

      if (this.selectedSalePersonId !== this.tmpSelectedSalePersonId) {
        return false
      }

      const isUpdated = isUpdatedData(this.salePersonList, this.tmpSelectedSalePerson)
      return isUpdated
    },
    isDeletedSalePerson: function () {
      if (this.selectedSalePersonId === '') {
        return false
      }

      if (this.selectedSalePersonId !== this.tmpSelectedSalePersonId) {
        return false
      }

      const isDeleted = isDeletedData(this.salePersonList, this.tmpSelectedSalePersonId)
      return isDeleted
    },
    _prepareSalePersonList: function () {
      const currentSalePersonId = get(this.specialOfferDetail, 'hotel.salePerson.id', '')
      let currentSalePerson = get(this.specialOfferDetail, 'hotel.salePerson', {})

      const salePersonList = this.salePersonList.map((item) => {
        if (Number(item.id) === Number(currentSalePersonId)) {
          return currentSalePerson
        }

        return item
      })

      if (currentSalePersonId !== '') {
        const salePerson = salePersonList.find(item => item.id === currentSalePersonId)

        if (salePerson === undefined) {
          salePersonList.push(currentSalePerson)
        }
      }

      this.displaySalePersonList = salePersonList.sort((prev, next) => {
        return (prev.firstName < next.firstName) ? -1 : 1
      })
    },
    _getUpdateSalePerson: function () {
      let salePersonResult = this.displaySalePersonList.find(salePerson => salePerson.id === this.selectedSalePersonId)
      this.signatureUrl = get(salePersonResult, 'signatureUrl', '')

      if (this.salePersonDataVersion === DATA_VERSION.LATEST) {
        salePersonResult = this.salePersonList.find(salePerson => salePerson.id === this.selectedSalePersonId)
        this.signatureUrl = get(salePersonResult, 'signatureUrl', '')
      }

      const isAddSignature = {
        isAddSignature: (this.signatureUrl === '') ? false : this.isAddSignature
      }

      salePersonResult = Object.assign({}, salePersonResult, isAddSignature)
      return salePersonResult
    }
  }
}

function _isAutoRefCode (refCodeFormat, specialOfferDetail) {
  const specialOfferId = get(specialOfferDetail, 'id', '')

  if (specialOfferId === '' && refCodeFormat.trim() !== '') {
    return true
  }

  const isAutoRefCode = Boolean(get(specialOfferDetail, 'autoRefCode', 0))
  return isAutoRefCode
}

function _initRefCode (specialOfferDetail, refCodeFormat, marketList) {
  let refCode = get(specialOfferDetail, 'refCode', '')
  const isAutoRefCode = _isAutoRefCode(refCodeFormat, specialOfferDetail)

  if (refCode === '' && isAutoRefCode) {
    refCode = genPreviewRefCode(specialOfferDetail, refCodeFormat, marketList)
  }

  return refCode
}

function _getPeriodDate (specialOfferValidPeriod, periodIndex) {
  const validPeriod = get(specialOfferValidPeriod, `${periodIndex}`, 'NaN-NaN-NaN')
  const periodDate = new Date(validPeriod)

  return (isNaN(periodDate)) ? '' : validPeriod
}

</script>

<style scoped>
  .label-contract {
    font-weight: bold;
    margin: 10px 0;
  }
</style>
